export default "__VITE_ASSET__Vo6dERRC__"